export default defineNuxtRouteMiddleware((to) => {
  const token = localStorage.getItem('token')
  const isAuthPage =
    ['/login', '/forgot-password'].includes(to.path) ||
    to.path.startsWith('/confirm-reset/')

  if (token && isAuthPage) {
    return navigateTo('/')
  }

  if (!token && !isAuthPage && to.path !== '/404') {
    return navigateTo('/login')
  }
})
